import React from "react";
import axios from "axios";
import toastr from "toastr"
import { API_URL } from "constants/constants";

export const VerifyWithdrawalButton = ({ rowData, call, token }) => {
  const [loadingRowId, setLoadingRowId] = React.useState(false);

  const handleVerify = async () => {
    setLoadingRowId(true)
    try {
      const response = await axios.post(
        `${API_URL}/admin/verifyPayStackTransfer`,
        {
          phone_number: rowData?.tel,
          reference: rowData?.transaction_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      toastr.success(response?.data?.message);
      call();
    } catch (error) {
      const errorMsg =
        error?.response?.data?.data?.message ??
        error?.reference?.[0] ??
        "An unexpected error occurred";
      toastr.error(errorMsg)
      call()
    } finally {
      setTimeout(() => {
        setLoadingRowId(false);
      }, 2000);
    }
  };

  return (
    <button
      className={`btn btn-success${loadingRowId === rowData?.reference_id ? ' bg-dark text-white' : ''}`}
      type="button"
      onClick={() => handleVerify()}
      disabled={loadingRowId}
    >
      {loadingRowId ? "Verifying..." : "Verify"}

    </button>
  )
}

export const ApproveWithdrawalButton = ({ rowData, call, token }) => {
  const [loadingRowId, setLoadingRowId] = React.useState(false);

  const handleApprove = async () => {
    setLoadingRowId(true)
    try {
      const response = await axios.post(
        `${API_URL}/admin/approvePaystackWithdrawal`,
        {
          phone_number: rowData?.msisdn,
          reference_id: rowData?.reference_id
          // account_number: rowData?.account_number,
          // bank_code: rowData?.bank_code,
          // amount: rowData?.amount,
          // reason: "",
          // account_name: rowData?.account_name,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      toastr.success(response?.data?.message);
      call();
    } catch (error) {
      const errorMsg =
        error?.response?.data?.data?.message ??
        error?.reference?.[0] ??
        "An unexpected error occurred";
      toastr.error(errorMsg)
      call()
    } finally {
      setTimeout(() => {
        setLoadingRowId(false);
      }, 2000);
    }
  }

  return (
    <button
      className="btn btn-success"
      type="button"
      onClick={() => handleApprove()}
      disabled={loadingRowId}
    >
      {loadingRowId ? "Approving..." : "Approve"}
    </button>
  )
}

export const DeclineWithdrawalButton = ({ rowData, call, token }) => {
  const [loadingRowId, setLoadingRowId] = React.useState(false);

  const handleDecline = () => {
    setLoadingRowId(true)
    try {
      const response = axios.post(
        `${API_URL}/admin/rejectWithdrawal`,
        {
          phone_number: rowData?.msisdn,
          reference_id: rowData?.reference_id,
          account_number: rowData?.account_number,
          bank_code: rowData?.bank_code,
          amount: rowData?.amount,
          reason: "",
          account_name: rowData?.account_name,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      toastr.success(response?.data?.message);
      call();
    } catch (error) {
      toastr.error(error?.response?.data?.data?.message)
      call()
    } finally {
      setTimeout(() => {
        setLoadingRowId(false);
      }, 2000);
    }
  }

  return (
    <button
      className="btn btn-danger"
      type="button"
      style={{ marginLeft: "10px" }}
      onClick={() => handleDecline()}
      disabled={loadingRowId}
    >
      {loadingRowId ? "Declining..." : "Decline"}
    </button>
  )
}